import { browserHistory } from 'react-router';

import { BUDGET_BASE_ROUTE } from '.';

const handleBudgetRouteChange = (
  pathname?: string,
  preventIfUnsaved = true,
  previousPathname?: string,
  markPaid?: boolean
) => {
  const cleanPath = pathname?.replace(BUDGET_BASE_ROUTE, '');
  browserHistory.replace({
    pathname: cleanPath ? `${BUDGET_BASE_ROUTE}${cleanPath}` : BUDGET_BASE_ROUTE,
    state: { preventIfUnsaved, previousPathname, markPaid },
  });
};

export default handleBudgetRouteChange;
